module.exports = __webpack_public_path__ + "img/logo_badge.b71ab7a1.png";